import { gql } from '@apollo/client';

export const REMOVE_KB_WEBSITE_URL = gql`
  mutation RemoveKbWebsiteUrl($input: RemoveKbWebsiteUrlInput!) {
    removeKbWebsiteUrl(input: $input) {
      statusCode
      message
    }
  }
`;
